import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./PatientDashboard.css";
import { useAuth } from "../Utils/AuthContext";
import { CgLogOff } from "react-icons/cg";
import { BsCalendarCheck } from "react-icons/bs";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Header from "../Header/Header";
import { BsPersonCircle } from "react-icons/bs";
import axiosConfig from "../../Service/AxiosConfig";
import { CgProfile } from "react-icons/cg";
import { PopupModal } from "../PopupModal/PopupModal";
import { clearTempForm } from "../../redux/BookingFormSlice";
import { persistor } from "../../store";
import { useDispatch } from "react-redux";
import { clearDocumentsDB } from "../../utils/indexedDB";
import { clearProfile } from "../../redux/ProfileSlice";
import { FaTimes } from "react-icons/fa";
import { HiMenuAlt2 } from "react-icons/hi";
const PatientDashboard = () => {
  const navigate = useNavigate();
  const { setIsLoggedIn } = useAuth();
  const [activeUrl, setActiveUrl] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const [showEditOptions, setShowEditOptions] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [isMobileProfileMenuOpen, setIsMobileProfileMenuOpen] = useState(false);
  const [error, setError] = useState("");
  const handleLogout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user");
    localStorage.removeItem("mobileno");
    // localStorage.removeItem("addressId");
    await clearDocumentsDB();
    dispatch(clearTempForm());
    dispatch(clearProfile());
    persistor.purge();
    localStorage.removeItem("persist:bookingForm");
    localStorage.removeItem("persist:profile");
    navigate("/");
    setIsLoggedIn(false);
  };

  const handleNavigate = (url) => {
    navigate(url);
    setIsMobileProfileMenuOpen(false);
  };

  useEffect(() => {
    setActiveUrl(window.location.pathname);
  }, [window.location.pathname]);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const userId = localStorage.getItem("user_id");
      const response = await axiosConfig.get(`/accounts/users/${userId}/`);
      setProfileImage(response.data.profile || null);
    } catch (error) {
      console.log("Error fetching profile:", error);
    }
  };
  const handleFileChange = async (e) => {
    setError("");
    setMessage("");
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("profile", file);

    try {
      const userId = localStorage.getItem("user_id");

      const uploadResponse = await axiosConfig.patch(
        `/accounts/profile_update/${userId}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      setProfileImage(uploadResponse?.data?.profile_image);
      setPopupType("success");
      setShowModal(false);
      setMessage(
        uploadResponse?.data?.message || "Profile updated successfully!",
      );
      setError("");
      fetchUserProfile();
    } catch (error) {
      console.log("Upload error:", error);
      setPopupType("error");
      setError(error?.response?.data?.error || "Something went wrong");
      setShowModal(false);
    }
  };
  const toggleMobileProfileMenu = () => {
    setIsMobileProfileMenuOpen(!isMobileProfileMenuOpen);
  };
  let mobile = localStorage.getItem("mobileno");

  return (
    <>
      <Header />
      <div className="content-1 patient-dashboard-parent">
        <button
          className="mobile-profile-menu-btn"
          onClick={toggleMobileProfileMenu}
        >
          {isMobileProfileMenuOpen ? (
            <FaTimes size={24} />
          ) : (
            <HiMenuAlt2 size={24} />
          )}
        </button>
        <div
          className={`patient-dashboard desktop ${
            isMobileProfileMenuOpen ? "open" : ""
          }`}
        >
          <div className="big-img-content">
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile"
                className="profile-div-img"
                onClick={() => setShowEditOptions(true)}
              />
            ) : (
              <BsPersonCircle
                size={40}
                className="profile-div-img"
                onClick={() => setShowEditOptions(true)}
                style={{ cursor: "pointer" }}
              />
            )}
            <span
              style={{ color: "#000" }}
              className="mt-3"
            >{`+91${mobile}`}</span>
            {showEditOptions && (
              <button
                className="profile-edit"
                onClick={() => {
                  setShowEditOptions(false);
                  setShowModal(true);
                }}
              >
                Edit
              </button>
            )}
          </div>

          <div
            className={`dashboard-item ${
              activeUrl === "/patient-dashboard/profile" ? "active" : ""
            }`}
            onClick={() => handleNavigate("/patient-dashboard/profile")}
          >
            <CgProfile size={16} />
            <span>Profile</span>
          </div>

          <div
            className={`dashboard-item ${
              activeUrl.startsWith("/patient-dashboard/bookings")
                ? "active"
                : ""
            }`}
            onClick={() => handleNavigate("/patient-dashboard/bookings")}
          >
            <BsCalendarCheck size={16} />
            <span>My Bookings</span>
          </div>
          {/* <div
            className={`dashboard-item ${
              activeUrl === "/patient-dashboard/family-members" ? "active" : ""
            }`}
            onClick={() => handleNavigate("/patient-dashboard/family-members")}
          >
            <MdOutlineGroups size={20} />
            <span>Family Members</span>
          </div> */}

          <div className="dashboard-item logout" onClick={handleLogout}>
            <CgLogOff size={16} />
            <span>Logout</span>
          </div>
        </div>
        <Outlet />
      </div>

      {showModal && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Choose Option</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "center" }}>
            <Button
              variant="secondary"
              className="mb-2"
              onClick={() => fileInputRef.current.click()}
              style={{ width: "100%" }}
            >
              📤 Upload From Gallery
            </Button>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              id="cameraInput"
              onChange={handleFileChange}
            />

            <Button
              variant="success"
              className="mb-2"
              onClick={() => document.getElementById("cameraInput").click()}
              style={{ width: "100%" }}
            >
              📷 Take Photo (Camera)
            </Button>
            <Button
              onClick={() => fileInputRef.current.click()}
              style={{ width: "100%" }}
            >
              📁 Upload From Drive
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*"
              style={{ display: "none" }}
            />
          </Modal.Body>
        </Modal>
      )}
      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          Navigation=""
          error={error}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export { PatientDashboard };
